<template>
  <div class="job" :class="{
    'job--with-motto': show.motto,
    'job--with-date': show.motto,
  }">
    <div class="job__card">
      <a class="job__link" :href="job.url" />
      <div class="job__logo">
        <img class="job__logo__image" :src="job.company.logo" loading="lazy">
      </div>
      <div class="job__text">
        <time v-if="show.date" class="job__timestamp" :datetime='job.updated_at'>
          {{ updatedAtTimeAgo }} ago
        </time>
        <h2 class="job__title">
          {{ job.title }}
        </h2>
        <div class="job__company">
          <a :href="job.company.url" class="job__company__link">
            <h3 class="job__company__name">
              {{ job.company.name }}
            </h3>
            <span v-if="show.motto && job.company.motto" class="job__company__motto">
              · {{ job.company.motto }}
            </span>
          </a>
        </div>
      </div>

      <div class="job__stats">
        <div class="job__stat">
          <span class="job__stat-icon">clock</span>
          <span class="job__stat-value" :title="commitment">{{ commitment }}</span>
        </div>
        <div v-if="job.remote" class="job__stat">
          <span class="job__stat-icon">wifi</span>
          <span class="job__stat-value" :title="translate('remote')">{{ translate('remote') }}</span>
        </div>
        <template v-else>
          <div v-if="job.remote_friendly" class="job__stat">
            <span class="job__stat-icon">wifi</span>
            <span class="job__stat-value" :title="translate('remote_friendly')">{{ translate('remote_friendly') }}</span>
          </div>
          <div class="job__stat">
            <span class="job__stat-icon">location</span>
            <span class="job__stat-value" :title="job.location">{{ job.location }}</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDistanceStrict, parseISO } from "date-fns";
import TranslationMixin from "../mixins/translation";

export default {
  mixins: [TranslationMixin],

  props: {
    show: {
      type: Object,
      default: () => ({
        motto: true,
        time: true,
        company: false,
      })
    },
    job: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean
    },
    context: {
      type: String
    }
  },

  computed: {
    commitment () {
      if (!this.job.commitment.name) return "";

      return this.job.commitment.name
        .split("_")
        .map(s => {
          return s.charAt(0).toUpperCase() + s.slice(1);
        })
        .join("-");
    },

    updatedAtTimeAgo() {
      return formatDistanceStrict(parseISO(this.job.updated_at), new Date());
    }
  },

  methods: {
    toggle() {
      this.toggled = !this.toggled;
    },
  }
};
</script>

<style lang="scss" scoped>
.job {
  &__card {
    margin: 0 -1.5rem;
    position: relative;
    display: grid;
    grid-template-areas: "logo text stats";
    grid-template-columns: 3.5rem 1fr 10rem;
    grid-gap: 1rem;
    align-items: center;
    padding: 1.5rem;
    @include max-width($bp_small) {
      grid-template-columns: 4rem 1fr 6rem;
    }

    &:hover, &:focus-within {
      .job__title {
        text-decoration: underline;
      }
    }
  }

  a {
    text-decoration: none;
  }

  & + & {
    border-top: $hr;
  }

  &__link {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
  }

  &__logo {
    grid-area: logo;

    &__image {
      max-width: 3.5rem;
      box-shadow: $box_shadow_20;
      border-radius: $radius_large;
      @include max-width($bp_small) {
        max-width: 4rem;
      }
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    grid-area: text;
  }

  &__timestamp {
    @extend %b3;
    color: var(--fg-2);
  }

  &__title {
    @extend %h5;
    text-transform: unset;
  }

  &__company {
    line-height: 1;
    &__link {
      position: relative;
      z-index: 2;
    }
    &__name, &__motto {
      display: inline-block;
      color: var(--fg-2);
      @include b3;
    }
  }
  &--with-motto &__company__name {
    font-weight: 700;
  }

  &__stats {
    @extend %b2;
    grid-area: stats;
    color: var(--fg-2);
  }

  &__stat {
    display: flex;
    grid-area: locale;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    white-space: nowrap;
  }
  &__stat-icon {
    @include icon;

    display: inline-block;
    flex: 0 0 auto;
    margin-right: 5px;
    width: 1rem;
    font-size: 85%;
    transform: translate(0px, 0.15rem);
  }
  &__stat-value {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// app/javascript/company/job.vue?53f612e7